import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { MainProgressBarEnum } from '../../app/enums/mainProgressBarEnum';
import { persistReducer } from 'redux-persist';
import storageSession from "redux-persist/es/storage/session";

const initialState = {
    currentStep: MainProgressBarEnum.Search,
    nextStep: MainProgressBarEnum.Search,
};

const mainProgressBarSlice = createSlice({
    name: 'mainProgressBarSlice',
    initialState,
    reducers: {
        setProgressBarStep(
            state,
            {
                payload,
            }: PayloadAction<{
                currentStep: MainProgressBarEnum;
                nextStep: MainProgressBarEnum;
            }>
        ) {
            state.currentStep = payload.currentStep;
            state.nextStep = payload.nextStep;
        },
        setNextBarStep(
            state,
            {
                payload,
            }: PayloadAction<{
                nextStep: MainProgressBarEnum;
            }>
        ) {
            state.nextStep = payload.nextStep;
        },
        setProgressBarInitialState(state) {
            state.currentStep = initialState.currentStep;
            state.nextStep = initialState.nextStep;
        },
    },
});

export const { setProgressBarStep, setNextBarStep, setProgressBarInitialState } = mainProgressBarSlice.actions;

const mainProgressBarPersistConfig = {
    key: "mainProgressBar",
    storage: storageSession
};

export const mainProgressBarReducer = persistReducer(mainProgressBarPersistConfig, mainProgressBarSlice.reducer);

export const selectCurrentStep = (state: RootState) => state.mainProgressBarSlice.currentStep;
export const selectNextStep = (state: RootState) => state.mainProgressBarSlice.nextStep;

export default mainProgressBarSlice.reducer;
